import { create } from 'zustand'

interface SessionState {
  token: string | null
  playerId: string | null
  displayName: string | null
  isAdmin: boolean
  lockAt: number
  groupId: string | null
  groupName: string | null
  setSession: (token: string, playerId: string, displayName: string, isAdmin: boolean, lockAt: number, groupId?: string | null, groupName?: string | null) => void
  clearSession: () => void
  setLockAt: (lockAt: number) => void
}

const STORAGE_KEY = 'wc2026_session'

function loadFromStorage(): Partial<SessionState> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    return JSON.parse(raw)
  } catch {
    return {}
  }
}

function saveToStorage(state: Partial<SessionState>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {}
}

const stored = loadFromStorage()

export const useSessionStore = create<SessionState>((set) => ({
  token: stored.token ?? null,
  playerId: stored.playerId ?? null,
  displayName: stored.displayName ?? null,
  isAdmin: stored.isAdmin ?? false,
  lockAt: stored.lockAt ?? 0,
  groupId: stored.groupId ?? null,
  groupName: stored.groupName ?? null,

  setSession: (token, playerId, displayName, isAdmin, lockAt, groupId = null, groupName = null) => {
    const next = { token, playerId, displayName, isAdmin, lockAt, groupId, groupName }
    saveToStorage(next)
    set(next)
  },

  clearSession: () => {
    localStorage.removeItem(STORAGE_KEY)
    set({ token: null, playerId: null, displayName: null, isAdmin: false, lockAt: 0, groupId: null, groupName: null })
  },

  setLockAt: (lockAt) => {
    const stored2 = loadFromStorage()
    saveToStorage({ ...stored2, lockAt })
    set({ lockAt })
  },
}))
